/* src/app/components/delete-address-warning/delete-address-warning.component.scss */
.header,
.header > div {
  gap: 15px;
}
.header ion-icon {
  width: 30px;
  height: 30px;
}
.header h1 {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
ion-button {
  margin: 0;
  min-height: 0;
}
ion-button > ion-icon {
  width: 24px !important;
  height: 24px !important;
  color: black;
}
ion-button.close {
  --border-radius: 0px;
}
ion-button.close::part(native) {
  padding: 0;
}
h2 {
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.address-info {
  padding: 15px;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  color: #949494;
  border-radius: 15px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}
.message {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.buttons > button {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  border-radius: 15px;
  padding: 14px 18px;
  transition: opacity 100ms linear ease-in;
  outline: none;
}
.buttons > button:last-of-type {
  color: white;
  background-color: #eb445a;
}
.buttons > button:last-of-type:hover {
  opacity: 0.9;
}
.buttons > button:last-of-type:active {
  background-color: #e44258;
  opacity: 1;
}
/*# sourceMappingURL=delete-address-warning.component-OPFXYG6K.css.map */
